"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFromRaw = parseFromRaw;
exports.parseToRaw = parseToRaw;
const common_1 = require("../../common/common");
const timeZones_1 = __importDefault(require("../../common/timeZones"));
const common_2 = require("../../js/common");
const ptoConfigNum_1 = require("../enums/ptoConfigNum");
const ptoConfigRawInput_1 = require("../enums/ptoConfigRawInput");
const PtoConfig_1 = require("../model/PtoConfig");
const PtoConfigDays_1 = require("../model/PtoConfigDays");
function parseFromRaw(ptoConfigRaw) {
    if (!ptoConfigRaw) {
        return new PtoConfig_1.PtoConfig({ groupId: 0 });
    }
    const { OnePerWeek, TwoPerWeek, ThreePerWeek, FourPerWeek, FivePerWeek, GrantDay } = ptoConfigRaw;
    const reqParam = {
        groupId: ptoConfigRaw.GroupID
    };
    const optional = {
        oneDay: extractAndParseRawConfigDays(ptoConfigNum_1.ptoConfigNum.onePerWeek, OnePerWeek),
        twoDays: extractAndParseRawConfigDays(ptoConfigNum_1.ptoConfigNum.twoPerWeek, TwoPerWeek),
        threeDays: extractAndParseRawConfigDays(ptoConfigNum_1.ptoConfigNum.threePerWeek, ThreePerWeek),
        fourDays: extractAndParseRawConfigDays(ptoConfigNum_1.ptoConfigNum.fourPerWeek, FourPerWeek),
        fiveDays: extractAndParseRawConfigDays(ptoConfigNum_1.ptoConfigNum.fivePerWeek, FivePerWeek),
        grantDay: (0, common_2.isZeroDate)(new Date(GrantDay)) ? undefined : (0, common_1.fromOplusTime)(new Date(GrantDay)),
    };
    return new PtoConfig_1.PtoConfig(reqParam, optional);
}
function extractAndParseRawConfigDays(numIndicator, ptoConfig) {
    const { Half, OneHalf, TwoHalf, ThreeHalf, FourHalf, FiveHalf, SixHalf } = ptoConfig;
    const reqParam = {
        numIndicator: numIndicator
    };
    const configDaysParam = {
        halfYear: Half,
        oneAndHalfYear: OneHalf,
        twoAndHalfYears: TwoHalf,
        threeAndHalfYears: ThreeHalf,
        fourAndHalfYears: FourHalf,
        fiveAndHalfYears: FiveHalf,
        sixAndHalfYears: SixHalf,
    };
    const days = new PtoConfigDays_1.PtoConfigDays(reqParam);
    days.setConfigDays(configDaysParam);
    return days;
}
function buildPtoConfigRawObject(ptoConfigDays, rawInputKey) {
    const { halfYear, oneAndHalfYear, twoAndHalfYears, threeAndHalfYears, fourAndHalfYears, fiveAndHalfYears, sixAndHalfYears, } = ptoConfigDays;
    const raw = {
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].half]: halfYear,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].oneHalf]: oneAndHalfYear,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].twoHalf]: twoAndHalfYears,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].threeHalf]: threeAndHalfYears,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].fourHalf]: fourAndHalfYears,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].fiveHalf]: fiveAndHalfYears,
        [ptoConfigRawInput_1.rawPtoConfigInputs[rawInputKey].sixHalf]: sixAndHalfYears,
    };
    return raw;
}
function parseGrantDayToRaw(ptoConfig) {
    let out = "0";
    const grantDate = ptoConfig.getGrantDay();
    if (grantDate) {
        const d = new Date();
        d.setFullYear(2000);
        d.setMonth(grantDate.getMonth());
        d.setDate(grantDate.getDate());
        out = (0, common_1.yearMonthDateString)(d, timeZones_1.default.ASIA_TOKYO);
    }
    return out;
}
function parseToRaw(ptoConfig) {
    const onePerWeek = buildPtoConfigRawObject(ptoConfig.getOneDayConfig(), ptoConfigRawInput_1.rawInputsFields.onePerWeek);
    const twoPerWeek = buildPtoConfigRawObject(ptoConfig.getTwoDaysConfig(), ptoConfigRawInput_1.rawInputsFields.twoPerWeek);
    const threePerWeek = buildPtoConfigRawObject(ptoConfig.getThreeDaysConfig(), ptoConfigRawInput_1.rawInputsFields.threePerWeek);
    const fourPerWeek = buildPtoConfigRawObject(ptoConfig.getFourDaysConfig(), ptoConfigRawInput_1.rawInputsFields.fourPerWeek);
    const fivePerWeek = buildPtoConfigRawObject(ptoConfig.getFiveDaysConfig(), ptoConfigRawInput_1.rawInputsFields.fivePerWeek);
    const grantDay = parseGrantDayToRaw(ptoConfig);
    const raw = {
        'grant-day': grantDay,
        ...onePerWeek,
        ...twoPerWeek,
        ...threePerWeek,
        ...fourPerWeek,
        ...fivePerWeek,
    };
    return raw;
}
